import React from 'react';
import {
  Box,
  IconButton,
  Button,
  Typography,
  useTheme,
} from '@mui/material';
import {
  NavigateBefore,
  NavigateNext,
} from '@mui/icons-material';

export const CustomToolbar = (toolbar: any) => {
  const theme = useTheme();
  
  const goToBack = () => {
    toolbar.onNavigate('PREV');
  };

  const goToNext = () => {
    toolbar.onNavigate('NEXT');
  };

  const goToCurrent = () => {
    toolbar.onNavigate('TODAY');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2,
        p: 1,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <IconButton onClick={goToBack} size="small">
          <NavigateBefore />
        </IconButton>
        <IconButton onClick={goToNext} size="small">
          <NavigateNext />
        </IconButton>
        <Button
          variant="outlined"
          size="small"
          onClick={goToCurrent}
          sx={{ ml: 1 }}
        >
          Today
        </Button>
      </Box>
      <Typography variant="h6" sx={{ fontWeight: 500 }}>
        {toolbar.label}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button
          variant={toolbar.view === 'month' ? 'contained' : 'outlined'}
          size="small"
          onClick={() => toolbar.onView('month')}
        >
          Month
        </Button>
        <Button
          variant={toolbar.view === 'week' ? 'contained' : 'outlined'}
          size="small"
          onClick={() => toolbar.onView('week')}
        >
          Week
        </Button>
      </Box>
    </Box>
  );
};
